export default "__VITE_ASSET__a5675db2__"